/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import * as size from '@constant/size';
import * as color from '@constant/color';
import ImageBlock from '@component/common/block/image-block';
import { useNavigate } from 'react-router-dom';
import { getInitialServicePath } from '@constant/common/route-path';
import otterLandingPageImg from '@asset/image/otter-landing-page-1.webp';
import React from 'react';
import TextBlock from 'component/common/block/text-block';
import Gap from '@component/common/gap';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const NotFound = () => {
  const navigate = useNavigate();
  const handleClickHome = () => navigate(getInitialServicePath());

  return (
    <Wrapper>
      <ImageBlock src={otterLandingPageImg} alt='otter' design={{ image: { height: '300px' } }} />
      <Gap height={size.MARGIN_2} />
      <TextBlock
        text={'Not Found Page 😢'}
        design={{
          text: {
            size: 'large',
            bold: true,
          },
        }}
      />
      <Gap height={size.MARGIN_3} />
      <TextBlock
        text='Home'
        design={{
          box: {
            width: '100px',
            height: '40px',
            backgroundColor: color.BLACK_1,
          },
          text: {
            size: 'medium',
            color: color.WHITE_1,
          },
        }}
        click={{ handler: handleClickHome }}
      />
    </Wrapper>
  );
};

export default NotFound;
